import { Link, Outlet } from 'react-router-dom';
import { Tab, Tabs, Grid, Tooltip } from '@mui/material';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import LoadingIconButton from 'src/components/LoadingIconButton';
import { useMatchRoute } from './hooks';
import { RouteProps } from './types';
import { getNavRoutes } from './utils';

type Props<T> = {
  context?: T;
  routes: RouteProps[];
  overview?: JSX.Element;
  refreshData?: () => void;
};

const style = {
  mb: 2,
  borderBottom: 1,
  borderColor: 'divider',
};

function RoutableTabsLayout<T>({
  context,
  routes,
  overview,
  refreshData,
}: Props<T>) {
  const tabRoutes = getNavRoutes(routes);
  const currentRoute = useMatchRoute() as RouteProps;
  const index = tabRoutes.indexOf(currentRoute);
  const value = index < 0 ? false : index;

  return (
    <>
      <Tabs sx={style} value={value}>
        {tabRoutes.map(({ path = '', meta }, index) => (
          <Tab
            key={path}
            label={meta?.title}
            value={index}
            component={Link}
            to={path}
          />
        ))}
        {refreshData && (
          <LoadingIconButton
            loading={false}
            onClick={() => refreshData()}
            style={{ marginLeft: 'auto' }}
          >
            <Tooltip title="Refresh">
              <CachedOutlinedIcon />
            </Tooltip>
          </LoadingIconButton>
        )}
      </Tabs>
      {overview ? (
        <Grid container spacing={2} rowGap={2}>
          <Grid item xs={9}>
            <Outlet context={context} />
          </Grid>
          <Grid item xs={3}>
            {overview}
          </Grid>
        </Grid>
      ) : (
        <Outlet context={context} />
      )}
    </>
  );
}

export default RoutableTabsLayout;
